<template>
  <div v-if="totalResults > perPage" class="masonry-pagination">
    <button
      class="pagination-arrow pagination-arrow--previous"
      :disabled="currentPage == 1"
      @click="changePage(currentPage - 1)"
    >
      <svg
        class="icon icon-arrow-pagination icon-arrow-pagination--rotate"
        aria-hidden="true"
        focusable="false"
      >
        <use xlink:href="#icon-arrow-pagination" />
      </svg>
    </button>
    <div class="pagination-container">
      <a
        v-for="(pageNumber, index) in paginationItems"
        :key="index"
        class="pagination-item-wrapper"
        :class="{
          active: pageNumber == currentPage,
          elipsis: pageNumber == '...',
        }"
      >
        <p class="pagination-item" @click="changePage(pageNumber)">
          <!-- eslint-disable -->
          {{ pageNumber < 10 ? '0' + pageNumber : pageNumber }}
        </p>
      </a>
    </div>
    <button
      class="pagination-arrow pagination-arrow--next"
      :disabled="currentPage === totalPages"
      @click="changePage(currentPage + 1)"
    >
      <svg
        class="icon icon-arrow-pagination"
        aria-hidden="true"
        focusable="false"
      ><use xlink:href="#icon-arrow-pagination" /></svg>
    </button>
  </div>
</template>

<script>
import range from 'lodash.range';

import { eventBus } from '../shared/event-bus';

export default {
  name: 'Pagination',
  props: ['currentPage', 'perPage', 'totalResults', 'totalPages'],
  data() {
    return {
      paginationItems: [],
    };
  },
  watch: {
    currentPage() {
      this.setPaginationArray();
    },
    totalPages() {
      this.setPaginationArray();
    },
  },
  mounted() {
    this.setPaginationArray();
  },
  methods: {
    changePage(newPage) {
      !isNaN(newPage) ? eventBus.updateCurrentPage(newPage) : null;
      window.scrollTo(300, 0);
    },
    setPaginationArray() {
      let paginationItems = [];
      if (this.totalPages <= 5) {
        paginationItems = range(1, this.totalPages + 1);
      } else if (this.totalPages == this.currentPage + 4) {
        paginationItems = range(this.currentPage, this.currentPage + 3);
        paginationItems.push(this.totalPages - 1, this.totalPages);
      } else if (this.totalPages > this.currentPage + 3) {
        paginationItems = range(this.currentPage, this.currentPage + 3);
        paginationItems.push('...', this.totalPages);
      } else {
        paginationItems = range(this.totalPages - 4, this.totalPages + 1);
      }
      this.paginationItems = paginationItems;
    },
  },
};
</script>
